import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const downloadSKP = 'data-skp-peserta-pelatihan-export';
const importDataSkpPeserta = 'data-skp-peserta-pelatihan/upload-skp-peserta/';
const ubahSkpPeserta = 'data-skp-peserta-pelatihan/ubah-skp-peserta/'
class DataSkpPesertaService {
    downloadSKP(pelatihan) {
        return axios.get(
            API_URL + downloadSKP + '?idWorkshopPelatihan=' + pelatihan,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

    importDataSkpPeserta(file,id) {
        const form = new FormData();
        form.append('file', file);
        return axios.put(API_URL + importDataSkpPeserta + id, form, {
            headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
        });
    }

    ubahSkpPeserta(formData) {
        var form = {
            skpTerstruktur : formData.skp_terstruktur,
            skpTidakTerstruktur : formData.skp_tidak_terstruktur,
            skpAssessment : formData.skp_assessment
        }
        return axios.put(
            API_URL + ubahSkpPeserta + formData.id_pelatihan_peserta,
            form,
            {
                headers: authHeader()
        });
    }

}

export default new DataSkpPesertaService();